import { Record } from "immutable";
import { UserBookmarkCount } from "models/interfaces/user-bookmark-count";

// -----------------------------------------------------------------------------------------
// #region Constants
// -----------------------------------------------------------------------------------------

const defaultValues: UserBookmarkCount = {
    id: "",
    name: "",
    imageFileId: undefined,
    count: 0,
};

// #endregion Constants

export default class UserBookmarkCountRecord
    extends Record(defaultValues)
    implements UserBookmarkCount
{
    // Do NOT set properties on immutable records due to babel and typescript transpilation issue
    // See https://github.com/facebook/create-react-app/issues/6506

    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: UserBookmarkCount) {
        if (params == null) {
            params = Object.assign({}, defaultValues);
        }

        super(params);
    }

    // #endregion Constructor

    // -----------------------------------------------------------------------------------------
    // #region Public Methods
    // -----------------------------------------------------------------------------------------

    /**
     * Merges new values into the record and returns a new instance.
     *
     * @param {Partial<UserBookmarkCount>} values
     */
    public with(values: Partial<UserBookmarkCount>): UserBookmarkCountRecord {
        return new UserBookmarkCountRecord(Object.assign(this.toJS(), values));
    }

    // #endregion Public Methods

    // -----------------------------------------------------------------------------------------
    // #region Private Methods
    // -----------------------------------------------------------------------------------------

    // #endregion Private Methods
}
